import React from 'react';
import cn from 'classnames';
import HiddenFileInput from 'src/components/common/Form/MediaUploaderSimple/HiddenFileInput';
import { useMediaUpload } from 'src/components/common/Form/MediaUploaderSimple/use-media-upload';
import Icon from 'src/components/common/Icon';

import css from './CreateHub.module.scss';

type UserMediaMessageProps = {
  userId: string;
  fieldName: string;
  mediaType: 'image' | 'video';
  url: string;
  fileName?: string;
  onRemove: () => void;
  onReupload: (url: string, fileName: string) => void;
};

export function UserMediaMessage({
  userId,
  mediaType,
  url,
  fileName,
  fieldName,
  onRemove,
  onReupload,
}: UserMediaMessageProps) {
  const type = mediaType === 'image' ? 'images' : 'videos';
  const [error, setError] = React.useState('');

  const { uploadFile, isLoading } = useMediaUpload({
    type,
    onUploadComplete: (url, fileName) => {
      onReupload(url, fileName);
    },
    onError: error => {
      setError(error);
    },
  });

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    await uploadFile(file);

    e.target.value = '';
  };

  return (
    <div className={css.userRow}>
      <div className={css.userMediaActions}>
        <button type="button" onClick={onRemove}>
          <Icon type="delete" />
        </button>
        <label>
          <Icon type="reupload" color={error ? 'red' : 'white'} />

          <HiddenFileInput
            name={fieldName}
            type={mediaType === 'image' ? 'images' : 'videos'}
            disabled={isLoading}
            onChange={handleFileChange}
          />
        </label>
      </div>
      <div className={cn(css.userMedia, isLoading && css.isLoading)}>
        {mediaType === 'image' ? (
          <img src={url} alt={fileName} className={css.userMediaPreview} />
        ) : (
          <video src={url} className={css.userMediaPreview} controls playsInline preload="metadata" />
        )}
      </div>
    </div>
  );
}

export function UserTextMessage({ text }: { text: string }) {
  return (
    <div className={css.userRow}>
      <div className={css.userText}>{text}</div>
    </div>
  );
}
